// Keep historical entries: IDs are stable destinations for old event links.
// Set bookingClosesAt only from an approved cutoff, including +02:00.
// Missing cutoff/payment contracts must never enable paid registration.
export const events = [
  {
    id: 'cape-town-2026-10-17', title: 'Cape Town Masterclass',
    date: '2026-10-17', dateLabel: '17 October 2026', location: 'Cape Town',
    price: 2000, currency: 'ZAR', status: 'interest', bookingClosesAt: null,
    formUrl: 'https://forms.gle/e4iis1zQeLRNXmqR8',
    description: 'A practical Cape Town masterclass for individuals ready to strengthen their stage presence, message clarity, and delivery.',
  },
  {
    id: 'johannesburg-masterclass', title: '2027 Public Speaking Masterclass',
    date: null, dateLabel: '2027 · Dates to be announced', location: 'Johannesburg',
    price: null, currency: 'ZAR', status: 'waiting-list', bookingClosesAt: null,
    showInAnnouncement: false,
    formUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf9XI_hqGrQg7_601c0SIRQBcGeSwelGLf4-3ajECnAf2QmtQ/viewform?usp=header',
    description: 'The 2027 Public Speaking Masterclass is coming to Johannesburg. Join the waiting list to receive registration announcements. Joining does not reserve a seat or require payment.',
  },
];

export const eventPath = (event) => `/book-now?event=${encodeURIComponent(event.id)}`;
export const eventPrice = (event) => event.price == null ? "Price to be announced" : `R${event.price} per person`;
export const johannesburgDate = (now = new Date()) => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(now);

export function eventState(event, now = new Date()) {
  if (['closed', 'cancelled', 'sold-out'].includes(event.status)) return event.status;
  if (event.date && event.date < johannesburgDate(now)) return 'past';
  if (event.bookingClosesAt) {
    if (!/T\d{2}:\d{2}(:\d{2})?\+02:00$/.test(event.bookingClosesAt)) return 'availability-unconfirmed';
    const cutoff = Date.parse(event.bookingClosesAt);
    if (!Number.isFinite(cutoff)) return 'availability-unconfirmed';
    if (now.getTime() >= cutoff) return 'closed';
  }
  if (!event.date) return 'waiting-list';
  if (!event.bookingClosesAt) return 'availability-unconfirmed';
  return event.status === 'interest' ? 'interest' : 'availability-unconfirmed';
}

export const eventLabels = {
  'waiting-list': 'Waiting list — no payment or reserved seat',
  'availability-unconfirmed': 'Booking availability unconfirmed — enquire before registering or paying',
  interest: 'Registration of interest — no reserved seat',
  closed: 'Booking closed', cancelled: 'Event cancelled', 'sold-out': 'Sold out', past: 'Past event — booking closed',
};
export const isClosed = (state) => ['closed', 'cancelled', 'sold-out', 'past'].includes(state);

export const masterclassWaitingList2027 = events.find((event) => event.id === "johannesburg-masterclass");
